import React from 'react';
import NumberFormat from 'react-number-format';
import { ZendeskAPI } from 'react-zendesk';
import { config } from '_config';

export default function ProductHeader({ classes, header, header2 }) {
  let phone = config.phone;
  const handleChat = () => {
    ZendeskAPI('webWidget', 'show');
    ZendeskAPI('webWidget', 'open');

    ZendeskAPI('webWidget:on', 'close', function () {
      ZendeskAPI('webWidget', 'hide');
    });
  };
  return (
    <div className={`reg-header${classes ? ` ${classes}` : ''}`}>
      {header2 ? (
        <h2>
          {header} {header2}
        </h2>
      ) : (
        <h2>{header}</h2>
      )}
      <p>
        Still have questions?{' '}
        <a href={'tel:' + phone}>
          Call{' '}
          <NumberFormat
            value={phone}
            displayType={'text'}
            format="# (###) ### - ####"
          />
        </a>{' '}
        or{' '}
        <span
          style={{
            color: '#F37217',
            fontFamily: 'MontserratBold',
            cursor: 'pointer',
          }}
          onClick={handleChat}
        >
          LIVE CHAT
        </span>{' '}
        with us for real-time support.
      </p>
    </div>
  );
}
